import { SearchableSelect } from "./SearchableSelect";
import { searchFinanzaemter, finanzamtBezeichnung, bufaAusBezeichnung } from "./finanzaemter";
import { PLACEHOLDERS } from "../validation";

/**
 * Finanzamt-Auswahl per Suche über Ort, Name, Amtsnummer und PLZ (aus der
 * generierten finanzaemter.json). Speichert einen Namen als String, wie bisher
 * — bei mehrdeutigen Namen mit angehängter Amtsnummer, sonst wäre die Auswahl
 * zwischen gleichnamigen Ämtern beim Speichern verfallen (siehe
 * finanzamtBezeichnung).
 *
 * `onUserEdit` signalisiert dem Formular eine manuelle Änderung (verhindert das
 * Überschreiben durch das Steuernummer-Prefill).
 */
export function FinanzamtSelect({
  label,
  name,
  value,
  onChange,
  onUserEdit,
  onBufa,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (v: string) => void;
  onUserEdit?: () => void;
  /**
   * Die Amtsnummer zur gewählten Bezeichnung — sie identifiziert das Amt,
   * der Name allein tut das nicht. Bei einem Freitext, der zu keinem Amt
   * passt, kommt `undefined`; dann soll der Aufrufer eine gespeicherte Nummer
   * löschen, damit Name und Nummer nicht auseinanderlaufen.
   */
  onBufa?: (bufa: string | undefined) => void;
}) {
  return (
    <SearchableSelect
      label={label}
      name={name}
      value={value}
      placeholder={PLACEHOLDERS.finanzamt}
      allowFreeText
      emptyText="Kein Finanzamt gefunden"
      onChange={(v) => {
        onUserEdit?.();
        onChange(v);
        onBufa?.(bufaAusBezeichnung(v));
      }}
      filter={(q) =>
        searchFinanzaemter(q)
          .slice(0, 40)
          .map((f) => ({
            value: finanzamtBezeichnung(f),
            label: finanzamtBezeichnung(f),
            // Die Amtsnummer steht immer im Hinweis, auch bei eindeutigen
            // Ämtern: Sie ist die Nummer, die auf jedem Bescheid steht, und
            // macht die Zeile prüfbar. Ort und PLZ fehlen bei einem einzigen
            // Datensatz — dann bleibt wenigstens die Nummer stehen.
            hint: [f.bufa, f.ort, f.plz].filter(Boolean).join(" · "),
          }))
      }
    />
  );
}

export default FinanzamtSelect;
